(function() {
'use strict';

angular
    .module('TR')
    .controller('HotelLanding', HotelLanding);

function HotelLanding(pagingService,
        scrollService,
        $scope,
        $rootScope,
        $location,
        reviewService,
        shortlistService,
        basketService,
        $timeout,
        destinationService,
        broker,
        currentDestination,
        hotelSearch,
        criteoService) {
    scrollTo(0, 0);
    if ($location.search().autoSearch !== '1') {
        $rootScope.unlockScreen($scope);
    }

    const cm = this;
    cm.hideRooms = false;
    cm.seoRoomLoader = true;
    cm.similarHotelsLoader = true;
    cm.showSimilarHotels = true;
    cm.scrollToReviews = scrollToReviews;
    cm.activeHotel = angular.copy($scope.hotel);
    cm.hotel = $scope.hotel;
    const { Title, Location, Province, Country } = $scope.hotel || {};
    cm.altText = [Title, Location, Province, Country].join(', ');
    cm.isHotelLandingPage = true;

    cm.loadingReviews = false;
    cm.loadingFirstReviews = false;
    cm.mapTab = mapTab;
    cm.reviewsTab = reviewsTab;
    cm.photosTab = photosTab;
    cm.createSeoLink = search => `${cm.hotel.Url}?${search}`;
    cm.search = search;
    cm.tab = 'detail';
    cm.tabClass = tabClass;
    cm.toggleShortlist = toggleShortlist;
    cm.currencyCode = TRPCONFIG.Domain.CurrencyCode;
    const pi = $location.search().pi;
    cm.paging = pagingService.data(pi == null ? 1 : parseInt(pi) + 1, 10, cm.hotel.CustomerReviewCount);
    cm.pageReviews = TRPCONFIG.Domain.ReviewsEnabled ? _getReviews : null;
    cm.isMobileDevice = TRPCONFIG.IsMobileDevice;
    cm.seoHideRooms = false;
    cm.seoRoomsLanding = cm.hotel.RoomDetails || [];
    cm.showMore = false;
    cm.showLessDescription = cm.hotel.Description ? cm.hotel.Description.substr(0, cm.hotel.Description.indexOf('</p>')) : '';
    cm.showLessDescriptionMobile = cm.hotel.Description ? cm.hotel.Description.split(' ').splice(0, 20).join(' ') : '';
    cm.toggleShowMoreLess = toggleShowMoreLess;
    cm.toggleSearchUnit = toggleSearchUnit;
    cm.showSearchUnit = false;
    cm.facilitiesIcon = code => {
        let codes = hotelSearch.getFacilitiesIcon();
        return codes[code];
    };

    if (cm.seoRoomsLanding.length > 0) {
        cm.seoRoomLoader = false;
    }


    const titleCase = str => {
        return str ? str.toLowerCase().split(' ').map(_.upperFirst).join(' ') : '';
    };

    const { AltTitles = [] } = cm.hotel;
    cm.hotelAlternativeTitles = AltTitles.map(title => {
        const titleCaseStr = titleCase(title);
        return `<li class="sc-c-list__item sc-c-list__item--inline-block">${titleCaseStr}</li>`;
    }).join(' | ');

    broker.publish('hotelViewed', cm.hotel);

    // Isolate hotel facilites
    cm.hotelFacilities = _.find(cm.hotel.FacilityGroups, fg => {
        return fg.name = 'Facilities';
    });

    currentDestination.getCurrentDestination().then(function(dest) {
        cm.destination = dest;
    });

    // Update hotel with all dest params
    destinationService.getDetails($scope.hotel).then(dest => {
        criteoService.enqueue(cm.hotel, 'hotel');
        cm.hotel = $scope.hotel;
        cm.hotelDestination = dest;
    });

    if (TRPCONFIG.Domain.ShortlistsEnabled) {
        shortlistService.isHotelShortlisted(cm.hotel).then(function(inList) {
            cm.hotelInShortlist = inList;
        });
    }

    $scope.$watch('cm.tab', function() {
        $rootScope.$emit('hideCloseButton');
    });

    angular.forEach(['detail'], function(val) {
        cm[`${val}Tab`] = function() {
            cm.tab = val;
        };
    });

    const locSearch = $location.search();
    switch (locSearch.pd) {
        case 'mp':
            $timeout(function() { cm.mapTab(); });
            break;
        case 'rv':
            cm.reviewsTab();
            if (locSearch.lr) {
                reviewService.likeReview.organic(locSearch.lr, true);
            }
            break;
        case 'ph':
            cm.photosTab();
            break;
    }

    if (TRPCONFIG.DeviceSettings.AutoLoadReviews && locSearch.pd !== 'rv') {
        reviewsTab();
    }

    function _getReviews(page, e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        cm.loadingReviews = true;
        if (page === 1) {
            cm.loadingFirstReviews = true;
        }
        reviewService.getReviews(cm.hotel, page - 1).then(function(result) {
            cm.reviews = result.reviews;
            cm.loadingReviews = false;
            cm.loadingFirstReviews = false;
            cm.paging = pagingService.data(page, 10, cm.hotel.CustomerReviewCount);
        });
    }

    function toggleSearchUnit() {
        cm.showSearchUnit = !cm.showSearchUnit;
        if (cm.showSearchUnit) {
            hotelSearch.toggleSearch('[ng-show="cm.showSearchUnit"]');
        }
    }

    function toggleShortlist() {
        shortlistService.toggleHotel(cm.hotel).then(function(inShortlist) {
            cm.hotelInShortlist = inShortlist;
        });
    }

    function toggleShowMoreLess() {
        cm.showMore = !cm.showMore;
    }

    function tabClass(tab) {
        if (tab instanceof Array) {
            return tab.indexOf(cm.tab) >= 0 ? 'active' : '';
        }
        return tab === cm.tab ? 'active' : '';
    }

    function scrollToReviews() {
        reviewsTab();
        scrollService.scrollTo('#reviewsSection', { animate: true });
    }

    function reviewsTab() {
        cm.tab = 'reviews';
        cm.reviews = [];
        _getReviews(cm.paging.page);
    }

    function photosTab() {
        cm.tab = 'photos';
    }

    function mapTab() {
        cm.tab = 'map';
        $scope.$broadcast('mapTabSelected');
        broker.publish('MAPLIGHTBOX', {
            hotel: cm.hotel,
            showInfoWindow: true,
        });
    }

    function search() {
        basketService.startWorkflow(basketService.hotelBooking).then(null, function(errors) {
            $scope.$emit('flash:error', errors);
        });
    }
}
})();
